import React from 'react';
import styled from 'styled-components';
import { SketchOutlined } from '@ant-design/icons';
import color from '../../configs/color';
// import { toRupiah } from '../../utils/commonUtils';

const Index = ({ returnOnAdsAmount }) => {
  return (
    <Wrapper>
      <div>
        <SketchOutlined />
      </div>
      <div>
        <div className="font-subtitle1_medium purple">
          {returnOnAdsAmount ? `${returnOnAdsAmount}%` : '0'}
        </div>
        <div className="font-paragraph_medium black2">Return on Ads</div>
      </div>
    </Wrapper>
  );
};

export default Index;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 20px 40px 16px 24px;
  gap: 16px;
  width: 226px;
  height: 86px;

  background: #fff8f3;

  border: 1px solid #ff9150;
  border-radius: 16px;
  .purple {
    color: ${color.purple1};
  }
  .anticon {
    font-size: 32px;
    color: ${color.orange1};
  }
`;
